import React from 'react';
import PropTypes from 'prop-types';
import {Image} from '@learningblocks/shared-components';
import Icon from '@common/images/move.svg';

const COLOR = {
  PRIMARY: '#003e6b',
  WHITE: '#FFFFFF',
};

export function MoveIcon(props) {
  let fill = COLOR.PRIMARY;

  if (props.color === COLOR.PRIMARY) {
    fill = COLOR.WHITE;
  }

  return (
    <svg
      className={props.className}
      alt=""
      xmlns='http://www.w3.org/2000/svg'
      width='14'
      height='14'
      viewBox='0 0 14 14'
      fill='none'>
      <path
        d='M14 7.00001L11.5 4.5V6.50001L7.50001 6.5V2.5H9.5L7.00004 0L4.5 2.5H6.50004V6.5L2.5 6.50001V4.5L0 7.00001L2.5 9.5V7.50002L6.50004 7.50001L6.50001 11.5H4.5L7.00004 14L9.5 11.5H7.50001L7.50005 7.49997L11.5 7.49999V9.5L14 7.00001Z'
        fill={fill}
      />
    </svg>
  );
}

MoveIcon.propTypes = {
  /**
   * ClassName
   */
  className: PropTypes.string,
  /**
   * Step Color
   */
  color: PropTypes.string,
};

MoveIcon.defaultProps = {
  className: '',
};
